import { CloudUploadOutlined } from "@ant-design/icons";
import { Button, Modal, notification } from "antd";
import { usePublishAssetsMutation } from "redux/media/media.api";
import { TooltipPerms } from "./TooltipPerms";
import { handleApiError } from "./handleApiError";
import { usePermsAssets } from "./usePermsAssets";
import { useQPSearch } from "./useQPSearch";
import { useSelected } from "./useSelected";

export const AssetsPublish = () => {
  const allowed = usePermsAssets("edit", true);
  const { searchState } = useQPSearch();
  const { selectedIds, clearSelected, allAssets } = useSelected();
  const [publishAssets] = usePublishAssetsMutation();
  const enabled = allowed && allAssets;

  const showConfirm = () => {
    return Modal.confirm({
      title: "Publish Assets",
      content: `Are you sure you want to publish ${selectedIds.length} assets?`,
      okText: "Publish",
      okButtonProps: {
        danger: true,
      },
      async onOk() {
        try {
          await publishAssets(selectedIds).unwrap();
          clearSelected();
          const key = Date.now().toString();
          const btn = (
            <Button
              type="primary"
              size="small"
              onClick={() => notification.close(key)}
            >
              Ok
            </Button>
          );

          notification.success({
            message: "Publishing Assets",
            description: `${selectedIds.length} assets are being published. This action may take a few minutes to complete.`,
            key,
            btn,
            duration: 0,
          });
        } catch (error) {
          handleApiError(error);
        }
      },
    });
  };

  return !searchState?.published_filter ? (
    <TooltipPerms action="Publish Assets" allowed={allowed} enabled={allAssets}>
      <Button
        shape="circle"
        icon={<CloudUploadOutlined />}
        onClick={showConfirm}
        disabled={!enabled}
      />
    </TooltipPerms>
  ) : null;
};
